import { cn } from "@/lib/utils";
import { textVariants } from "@/src/components/Text/Text";
import { useHistory } from "@/src/hooks/useHistory";
import _ from "lodash";
import moment from "moment";
import { useTranslation } from "react-i18next";

const History = () => {
  const { history } = useHistory();
  const { t } = useTranslation();

  if (_.isEmpty(history))
    return (
      <div className="flex justify-center items-center mt-5">
        <span className={textVariants()}>
          {t("app.home.transactions.empty")}
        </span>
      </div>
    );

  return (
    <div className="overflow-y-scroll h-[400px] flex flex-col gap-5 mt-3 ">
      {history?.map((item, index: number) => (
        <span key={index} className="flex justify-between h-10">
          <span className="flex gap-3">
            <img src={item?.coin_image} alt="coin" className="h-8 w-8" />
            <div className="grid">
              <span className="text-sm font-medium">
                <span className={textVariants({ case: "capitalize" })}>
                  {item?.trans_type}
                </span>{" "}
                <span className={textVariants({ case: "uppercase" })}>
                  {item?.coin_ticker}
                </span>{" "}
              </span>
              <span className={textVariants({ size: "xs", variant: "desc" })}>
                {item?.status}
              </span>
            </div>
          </span>
          <div className="grid">
            <span
              className={cn(textVariants({ font: "medium" }), "text-right")}
            >
              ${item?.amount}
            </span>
            <span className={textVariants({ size: "xs", variant: "desc" })}>
              {moment(item?.created_date).format("ll")}
            </span>
          </div>
        </span>
      ))}
    </div>
  );
};

export default History;
